export const mainConfig = {
    'JP': {
        menus: [
        ],
        headerTitle: '獅子商店',
        signWithId: '領主IDを入力してください',
        idPlaceHolder: 'こちらに領主IDを入力してください',
        singWithName: '領主名を入力してください',
        namePlaceHolder: '領主名',
        enterBirthday: '年齢を選択してください',
        birthdayPlaceholder: '年齢入力',
        emailInput: 'E-Mailアドレス（購入履歴送付用）',
        emailInputPlaceholder: 'E-Mailアドレスをご入力ください。',
        proceed: '次へ',
        itemOffers: 'ジェム',
        problemFindingId: '領主IDを忘れた場合はこちら',
        errors: {
            WENT_WRONG: '予期せぬ不具合が発生しました',
            PLAYER_NOT_FOUND: '正しい領主名を入力してください。ご不明な場合は以下の「領主IDと領主名の確認方法」でお確かめください。',
            EMPTY_INPUT_ID: '領主IDを入力してください',
            EMPTY_INPUT_NAME: '領主名を入力してください',
            ENTER_AGE: '年齢を選択してください。',
            AGE_NEEDED: '18歳以上の成年の方のみ、本サイトをご利用いただけます',
            MAIL_EMPTY: 'E-Mailアドレスが入力されていません。',
            MAIL_INVALID: '正しいE-Mailアドレスをご入力ください。'
        },
        loginTitle: 'ショップ',
        logout: 'ログアウト',
        reviewOrder: '注文内容の確認',
        remove: '商品の削除',
        item: '商品',
        discount: '割引',
        orderTotal: '合計：',
        orderName: '商品名：',
        orderPrice: '価格：',
        orderQuantity: '個数：１個',
        checkout: '購入手続き',
        backToShop: '獅子商店に戻る',
        proceedToCheckout: 'この内容で購入する',
        notFound: {
            error: '不具合が発生しました。\n 再度お試しください。(エラーコード：404)',
            noSuchPage: '該当のページは存在しません'
        },
        checkoutResult: {
            successTitle: '手続きが完了しました',
            transactionId: '注文ID：',
            successInfo_1: 'ゲーム内の書簡に購入したアイテムが届きます。',
            successInfo_2: 'なお、書簡が届くまで数分かかる場合があります。ご了承ください。',
            successInfo_3: '',
            successInfo2_1: 'この画面のスクリーンショットを撮影の上、保存してください。または上記の注文IDを必ず控えておいてください。お問い合わせの際に必要となる番号です。',
            successInfo2_2: '',
            successInfo2_3: '',
            errorTitle: '購入手続き中に問題が発生しました。',
            errorInfo: '再度お試しいただくか、弊社サポートまでお問い合わせください：',
            genericTitle: 'ご購入手続き中の注文ID：',
            genericText1: '「支払う」ボタンより次にお進みいただくと、お支払いに関する手続きが開始されます。',
            genericText2: '正常に購入が完了した場合、ゲーム内の書簡に購入したアイテムが届きます。',
            genericText3: 'ご購入の手続き中に何らかの問題が生じた際は、時間をおいて再度お試しいただくか、弊社サポートまでお問い合わせください。',
        },
        findIdTitle: '領主IDと領主名の確認方法',
        findIdStep1: '1. 主城画面の左上（赤い枠）にあるアイコンをタップしてください',
        findIdStep2: '2. 次の画面の中央一番上（１）には領主名、一番右下（２）にはIDが書かれています、コピーをタップするとIDのコピーができます',
        // findIdStep3: '3. アカウントボタンをタップしてください',
        // findIdStep4: '4. アイコンの横に君主名が記載されています。コピーボタンをタップの上、君主IDをコピーしてください。',
        backToLogin: 'ログインに戻る',
        offerEnds: '残り時間：',
        agreeWithTermsAndCond: '利用規約に同意の上、上記の商品を購入します',
        privacyPolicy: 'プライバシーポリシー',
        termsAndConditions: '利用規約',
        paymentoffunds: '特定商取引法',
        fundsettlement: '資金決済法',
        support: 'お問い合わせ',
        filter: 'カテゴリー',
        filterClose: '適用して閉じる',
        filterErr: '全てのカテゴリーを無効にすることはできません',
        noProducts: '該当する商品は存在しません。',
        free: '無料獲得',
        fAndQ: 'お買い物Q&A',
        shopGuide: 'お買物ガイド',
        searchBarPlaceholder: '商品名やカテゴリーを入力（２文字以上）',
        leftPurchases: '残り回数：',
        saveMailText: 'メールアドレスを保存します',
        successfulSavedMail: 'メールアドレスを保存しました',
        successfulUnsavedMail: 'メールアドレスは保存されていません',
        newTabRestrictions: '新しい画面を開くために、ポップアップを許可してください。（お手続き等で必要になります）',
        ageConfirm: {
            title: '終境商店',
            subTitle: '年齢確認',
            message1: '本コンテンツは、18歳以上の方のみ購入できます。',
            message2: '※18歳未満の方はご利用いただけません。',
            message3: '※年齢の虚偽申告は禁止されています。',
            selectLabel: '年齢を選択してください',
            cancelButton: '退出',
            confirmButton: '私は18歳以上です'
        },
    }
}